export interface SelectOption {
	label: string;
	value: string;
}

export class Form {
	fields: {
		[type: string]: FormDef;
	};
	isValid: boolean;
	constructor(fields: { [type: string]: FormDef }) {
		this.fields = fields;
		this.isValid = false;
	}
}

export class FormDef {
	value: any;
	validators: Array<(data: any, formData: any) => string | null>;
	error: string[];
	virgin: boolean;
	constructor(value: any, validators: Array<(data: any, formData: any) => string | null>) {
		this.value = value;
		this.validators = validators;
		this.error = [];
		this.virgin = true;
	}
}

export type Enum = {
	[id in string | number]: string;
};

export enum ProcessHandleResult {
	RETRY = 'RETRY',
	END = 'END',
}
